// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__h2uun","cover_caption":"Carousel_cover_caption__akR0A","cover_thumb":"Carousel_cover_thumb__xab5x","mobile_drag":"Carousel_mobile_drag__o3VGZ"};